import React from "react";
import "./Common_Category_Card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";

const Common_Category_Card = ({ imgSrc, title, onClick, catDiscount }) => {
  const app_setup = useSelector((state) => state.master.app_setup);

  const discountPercentage =
    Number(catDiscount) > 0
      ? Number(catDiscount)
      : Number(app_setup?.global_discount) > 0
      ? Number(app_setup.global_discount)
      : 0;

  return (
    <section className="Common_Category_Card">
      {discountPercentage > 0 && (
          <div className="discount">{discountPercentage}% Off</div>
        )}
      <div className="img_holder" onClick={onClick}>

        <img src={imgSrc} className="prod_img" alt={title} />
      </div>

      <p className="title_text" onClick={onClick}>
        {title}{" "}
        <FontAwesomeIcon icon={faLongArrowRight} className="inner_icon" />
      </p>
    </section>
  );
};

export default Common_Category_Card;
